import React, { forwardRef } from 'react'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import moment from 'moment'
import { Tooltip } from 'react-tooltip'

export default class SelectBox extends React.Component {
    constructor(props) {
        super(props)
        this.changeOption = this.changeOption.bind(this)
        this.select = this.select.bind(this)
        this.onOpen = this.onOpen.bind(this)

        var options = []
        if (this.props.time) {
            var start = moment().startOf('day')
            while (start.isSame(moment(), 'day')) {
                options.push(start.format('HH:mm'))
                start.add(this.props.time, 'minutes')
            }
        }
        this.state = {
            options,
            filterText: ''
        }
    }

    changeOption(event) {
        if (typeof this.props.onChange !== 'function') return
        this.props.onChange(event)
    }

    select(option) {
        if (typeof this.props.onChange !== 'function') return
        this.props.onChange({
            currentTarget: {
                id: this.props.id,
                name: this.props.name,
                value: option.value,
                group: option.group
            },
            target: {
                id: this.props.id,
                name: this.props.name,
                value: option.value,
                group: option.group
            },
            multiple: this.props.multiple
        })
    }

    updateFilter(val) {
        this.setState({ filterText: val })
        if (this.props.updateFilter) {
            this.props.updateFilter(val)
        }
    }

    onOpen(props) {
        if (this.props.onOpen) {
            this.props.onOpen(props)
        }
        if (this.refs?.selectedOption && !this.props.multiple) {
            const selected = this.refs.selectedOption
            if (selected && selected.scrollIntoView) {
                selected.scrollIntoView({ block: 'nearest', inline: 'nearest' })
            } else if (selected && selected.length) {
                selected[0].scrollIntoView({ block: 'nearest', inline: 'nearest' })
            }
        }
    }

    render() {
        const { headerText } = this.props
        var theOpts = this.props.data || this.state.options
        var optsOut = []
        var currOptions = this.props.value
        if (currOptions === null) currOptions = undefined
        // if (typeof currOptions === "string") currOptions = currOptions.toLowerCase();
        var multiOptions = []
        if (this.props.multiple) {
            if (Array.isArray(currOptions)) {
                multiOptions = currOptions
            }
        }
        var errorTxt = []
        var thisClasses = 'selectbox'
        if (this.props.className) thisClasses += ' ' + this.props.className

        if (this.props.error && this.props.error.length > 0) {
            if (this.props.error != ' ') {
                errorTxt.push(<FormError key={'err'}>{this.props.error}</FormError>)
            }
        }

        let groups = []
        var found = 0
        if (Array.isArray(theOpts)) {
            found = 1
            optsOut = theOpts.map((o, i) => {
                if (typeof o === 'object') {
                    var val = o.value
                    // if (typeof val == "string") val = val.toLowerCase();

                    var props = {
                        filter: o.filter,
                        value: val,
                        label: o.label,
                        key: i,
                        labelOverride: o.labelOverride,
                        selected: val == this.props.value,
                        iconRight: o.iconRight,
                        iconRightTooltip: o.iconRightTooltip,
                        iconLeft: o.iconLeft,
                        illustration: o.illustration,
                        sublabel: o.sublabel,
                        tooltip: o.tooltip,
                        iconLeftColor: o.iconLeftColor,
                        customLeft: o.customLeft,
                        customRight: o.customRight,
                        postHogTag: o.postHogTag,
                        noCheckBox: o.noCheckBox
                    }
                    if (multiOptions.some((mO) => mO == o.value)) {
                        props.selected = true
                    }

                    if (!props.selected) {
                        if (typeof mO === 'string' && typeof o.value === 'string') {
                            if (mO.toLowerCase() == o.value.toLowerCase()) props.selected = true
                        }
                    }

                    if (o.disabled) {
                        props.disabled = true
                    }

                    if (o.group && !groups.some((g) => g === o.group)) groups.push(o.group)
                    props.group = o.group
                    return props
                } else {
                    var val = o
                    // if (typeof val == "string") val = val.toLowerCase();
                    var props = { value: val, label: val, key: i, selected: val === this.props.value }
                    if (multiOptions.find((mO) => mO == o)) {
                        props.selected = true
                    }
                    return props
                }
            })
        } else if (typeof theOpts === 'object') {
            found = 1
            optsOut = Object.keys(theOpts).map((o, i) => {
                if (typeof theOpts[o] === 'object') {
                    var props = {
                        value: theOpts[o].index,
                        label: o,
                        key: theOpts[o].index,
                        selected: theOpts[o].index === this.props.value
                    }
                    if (multiOptions.find((mO) => mO == theOpts[o].index)) {
                        props.selected = true
                    }
                    return props
                } else {
                    var val = theOpts[o]
                    // if (typeof val == "string") val = val.toLowerCase();
                    var props = { value: val, key: theOpts[o], label: o, selected: val === this.props.value }
                    if (
                        multiOptions.find((mO) => {
                            if (typeof mO === 'string') {
                                return mO.toLowerCase() === theOpts[o]
                            } else {
                                return mO == theOpts[o]
                            }
                        })
                    ) {
                        props.selected = true
                    }
                    return props
                }
            })
        } else {
            for (var x in theOpts) {
                var val = theOpts[x]
                // if (typeof val == "string") val = val.toLowerCase();
                var props = { value: val, key: x, label: x, selected: val === this.props.value }
                if (multiOptions.find((mO) => mO == theOpts[x])) {
                    props.selected = true
                }

                optsOut.push(props)
            }
        }
        var thisStyle = {
            width: '100%'
        }

        if (
            this.props.placeholder &&
            !this.props.hideplaceholder &&
            (!this.props.value || this.props.value == '-1') &&
            !optsOut.some((o) => o.group)
        ) {
            optsOut.unshift({ label: this.props.placeholder, value: undefined, selected: false, placeholder: true })
        }

        if (this.props.style) {
            if (this.props.style.width) {
                thisStyle.width = this.props.style.width
            }
            if (this.props.style.marginBottom) {
                thisStyle.marginBottom = this.props.style.marginBottom
            }
            if (this.props.style.height) {
                thisStyle.height = this.props.style.height
            }
            if (this.props.style.paddingBottom) {
                thisStyle.paddingBottom = this.props.style.paddingBottom
            }
        }

        const outerStyle = Object.assign({ position: 'relative' }, this.props.outerstyle || this.props.outerStyle || {})

        let outerClassName = 'textInputWrapper'
        if (this.props.outerClassName) outerClassName += ' ' + this.props.outerClassName

        let label = ''
        if ((this.props.label && this.props.labelOptions) || this.props.labelOptions) {
            label = (
                <div className='txtInput_label_flex'>
                    <div className='txtInput_label'>{this.props.label}</div>
                    <div className='txtInput_labelOptions'>{this.props.labelOptions}</div>
                </div>
            )
        } else if (this.props.label) {
            label = <div className='txtInput_label'>{this.props.label}</div>
        }

        let explainer = ''
        if (this.props.explainer) {
            explainer = <div className='txtInput_explainer'>{this.props.explainer}</div>
        }

        if (this.props.explainerEnd) {
            explainer = (
                <div className='quickFlex' style={{ justifyContent: 'space-between' }}>
                    {explainer} {this.props.explainerEnd}
                </div>
            )
        }

        let iconLeftMarginRight = 12
        if (Object.keys(this.props).includes('iconLeftMarginRight')) {
            iconLeftMarginRight = this.props.iconLeftMarginRight
        }

        var iconRight = []
        if (this.props.iconRight) {
            iconRight.push(this.props.iconRight)
        }
        if (iconRight.length) {
            iconRight = <div className='textInputIcon'>{iconRight}</div>
            // thisStyle.paddingRight = '40px'
        }

        let header = (
            <div>
                {!!this.props.inlineLabel && <span style={{ color: '#595c61' }}>{this.props.inlineLabel}: </span>}
                <span style={{ color: 'var(--neutral-400)' }}>
                    {this.props.placeholder || this.props.placeholderNoSelect || 'Select'}
                </span>
            </div>
        )
        if (this.props.value !== undefined || optsOut.some((o) => o.value === undefined)) {
            let found = optsOut.find((d) => d.value == this.props.value)
            if (!found && this.props.otherData?.length) {
                found = this.props.otherData.find((d) => d.value == this.props.value)
            }
            if (found) {
                header = (
                    <div style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
                        {!!found.iconLeft && !this.props.hideIconInHeader && (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginRight: 12
                                }}
                            >
                                <Icons icon={found.iconLeft} color={found.iconLeftColor} />
                            </div>
                        )}
                        {!!found.illustration && !this.props.hideIconInHeader && (
                            // The closed field shows a scaled down copy of the drawing for
                            // the option you picked. 28x18 is exactly half of the 56x36
                            // artwork, so the shape is not stretched, and 18px fits inside
                            // the field's 28px of usable height without making it taller.
                            <div
                                data-test='select-header-illustration'
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginRight: iconLeftMarginRight,
                                    flex: '0 0 auto'
                                }}
                            >
                                <Icon name={found.illustration} width={28} height={18} />
                            </div>
                        )}
                        {!!found.customLeft && (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginRight: 12
                                }}
                            >
                                {found.customLeft}
                            </div>
                        )}
                        {!!this.props.inlineLabel && <div style={{ color: '#595c61' }}>{this.props.inlineLabel}: </div>}
                        <div
                            className={!!this.props.inlineLabel ? 'text-heavy' : ''}
                            style={{
                                whiteSpace: 'nowrap',
                                flexGrow: 1,
                                textAlign: 'left',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                ...this.props.headerContentStyle
                            }}
                        >
                            {found.labelOverride || found.label}
                        </div>
                        {!!found.iconRight && !this.props.hideIconInHeader && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Icons icon={found.iconRight} style={{ marginLeft: 3 }} />
                            </div>
                        )}
                    </div>
                )
            }
        }

        if (this.props.multiple && Array.isArray(this.props.value) && this.props.value.length) {
            const values = this.props.value.map((v) => optsOut.find((o) => o.value == v)).filter((v) => !!v)
            if (values.length) {
                if (values.length === 1) {
                    if (this.props.inlineLabel) {
                        header = (
                            <div>
                                <span style={{ color: '#595c61' }}>{this.props.inlineLabel}: </span>
                                <span className='text-heavy'>{values[0].label}</span>
                            </div>
                        )
                    } else {
                        header = values[0].label
                    }
                } else {
                    if (this.props.inlineLabel) {
                        header = (
                            <div>
                                <span style={{ color: '#595c61' }}>{this.props.inlineLabel}: </span>
                                <span className='text-heavy'>{values.length + ' selected'}</span>
                            </div>
                        )
                    } else {
                        header = (
                            <div style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
                                <div
                                    style={{
                                        whiteSpace: 'nowrap',
                                        flexGrow: 1,
                                        textAlign: 'left',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {values.length + ' selected'}
                                </div>
                            </div>
                        )
                    }
                }
            }
        }

        if (this.props.multiple && !this.props.value?.length && this.props.inlineLabel) {
            header = (
                <div>
                    <span style={{ color: '#595c61' }}>{this.props.inlineLabel}: </span>
                    <span className='text-heavy'>
                        {this.props.placeholder || this.props.placeholderNoSelect || 'Select'}
                    </span>
                </div>
            )
        }

        if (this.props.fixedHeader) {
            header = this.props.fixedHeader
        }

        if (this.props.filter && this.state.filterText) {
            optsOut = optsOut.filter((o) => {
                if (typeof o.filter === 'string') {
                    return o.filter.toLowerCase().indexOf(this.state.filterText.toLowerCase()) > -1
                }
                if (typeof o.label !== 'string') return true
                return o.label.toLowerCase().indexOf(this.state.filterText.toLowerCase()) > -1
            })
        }

        const hasIconOptions = optsOut.some((o) => o.iconLeft || o.illustration)

        let options = []
        if (groups.length) {
            // const placeholder = optsOut.find(o => o.placeholder = true)
            // if (placeholder) {
            //     options.push(<Option item={placeholder} selected={placeholder.selected} onSelect={this.select} disabled={placeholder.disabled} iconRight={placeholder.iconRight} />)
            // }

            if (this.props.groupOrder && this.props.groupOrder.length) {
                const preferred = this.props.groupOrder
                groups.sort((a, b) => {
                    const ai = preferred.indexOf(a)
                    const bi = preferred.indexOf(b)
                    if (ai === -1 && bi === -1) {
                        return this.props.orderGroups ? a.localeCompare(b) : 0
                    }
                    if (ai === -1) return 1
                    if (bi === -1) return -1
                    return ai - bi
                })
            } else if (this.props.orderGroups) {
                groups.sort((a, b) => a.localeCompare(b))
            }

            groups.forEach((group) => {
                const groupOptions = optsOut
                    .filter((o) => o.group === group)
                    .map((o, i) => (
                        <Option
                            key={o.value || o.id || i}
                            wrapText={this.props.wrapText}
                            item={o}
                            group={o.group}
                            tooltip={o.tooltip}
                            selected={o.selected}
                            ref={o.selected ? 'selectedOption' : undefined}
                            onSelect={this.select}
                            disabled={o.disabled}
                            iconRight={o.iconRight}
                            illustration={o.illustration}
                            checkbox={this.props.multiple}
                            iconLeftMarginRight={iconLeftMarginRight}
                            hasIconOptions={hasIconOptions}
                        />
                    ))
                options.push(<Group key={'select_group_' + group} name={group} options={groupOptions} />)
            })
            const noGroup = optsOut.filter((o) => !o.group && !o.placeholder)
            if (noGroup.length) {
                const groupOptions = noGroup.map((o, i) => (
                    <Option
                        key={o.value || o.id || i}
                        wrapText={this.props.wrapText}
                        item={o}
                        selected={o.selected}
                        ref={o.selected ? 'selectedOption' : undefined}
                        tooltip={o.tooltip}
                        onSelect={this.select}
                        disabled={o.disabled}
                        iconRight={o.iconRight}
                        iconRightTooltip={o.iconRightTooltip}
                        iconLeft={o.iconLeft}
                        illustration={o.illustration}
                        checkbox={this.props.multiple}
                        iconLeftMarginRight={iconLeftMarginRight}
                        hasIconOptions={hasIconOptions}
                    />
                ))
                options.push(<Group key={'select_group_blank'} name='Other' options={groupOptions} />)
            }
        } else {
            options = optsOut.map((o, i) => (
                <Option
                    wrapText={this.props.wrapText}
                    key={i}
                    item={o}
                    selected={o.selected}
                    ref={o.selected ? 'selectedOption' : undefined}
                    tooltip={o.tooltip}
                    onSelect={this.select}
                    disabled={o.disabled}
                    iconRight={o.iconRight}
                    iconRightTooltip={o.iconRightTooltip}
                    iconLeft={o.iconLeft}
                    iconLeftColor={o.iconLeftColor}
                    illustration={o.illustration}
                    checkbox={this.props.multiple}
                    customLeft={o.customLeft}
                    customRight={o.customRight}
                    noCheckBox={o.noCheckBox}
                    iconLeftMarginRight={iconLeftMarginRight}
                    hasIconOptions={hasIconOptions}
                />
            ))
        }

        let useUl = true
        if (!options.length && !this.props.hideNoOptions)
            options = [
                <Option
                    wrapText={this.props.wrapText}
                    key={-1}
                    item={{ label: '', value: '' }}
                    selected={false}
                    onSelect={() => {}}
                    iconLeftMarginRight={iconLeftMarginRight}
                />
            ]
        if (!options.length && this.props.hideNoOptions) useUl = false

        let buttonClass = 'button-plain '
        if (this.props.error) {
            buttonClass += ' button-red-outline '
        }
        if (this.props.buttonClass) {
            buttonClass = this.props.buttonClass
        }

        return (
            <div style={outerStyle} className={outerClassName}>
                {headerText && <div>{headerText}</div>}

                {label}

                <ButtonSelect
                    usePortal={this.props.usePortal}
                    buttonStyle={this.props.buttonStyle}
                    btnClass={buttonClass}
                    hideIconRight={this.props.hideIconRight}
                    onBlur={this.props.onBlur}
                    postHogTag={this.props.postHogTag}
                    dropdownStyle={this.props.dropdownStyle}
                    overrideButtonClass={!!this.props.buttonClass}
                    dropDownParentProperties={this.props.dropDownParentProperties}
                    filter={this.props.filter}
                    filterText={this.props.filterText}
                    updateFilter={this.updateFilter.bind(this)}
                    fixedHeight={true}
                    clearAll={this.props.clearAll}
                    selectAll={this.props.selectAll}
                    autoClose={!this.props.multiple}
                    iconRight={this.props.iconRight}
                    iconLeft={this.props.iconLeft}
                    inputType={this.props.inputType}
                    dataAttribute={this.props.dataAttribute}
                    onOpen={this.onOpen}
                    onClose={this.props.onClose}
                    customHeader={this.props.customHeader}
                    // data={options}
                    disabled={this.props.disabled}
                    autoWidth={this.props.autoWidth}
                    headerText={header}
                    style={thisStyle}
                    name={this.props.name}
                    className={thisClasses}
                    loadingData={this.props.loadingData}
                    fixedHeightLarge={this.props.fixedHeightLarge}
                    align={this.props.align}
                    topCta={this.props.topCta}
                    topAuthWidth={this.props.topAuthWidth}
                    scrollToSelected={true}
                >
                    {useUl && <ul>{options}</ul>}
                    {!useUl && options}
                </ButtonSelect>

                {errorTxt}
                {explainer}
            </div>
        )
    }
}

const Option = forwardRef(
    (
        {
            item,
            onSelect,
            selected,
            disabled,
            iconRight,
            iconLeft,
            checkbox,
            tooltip,
            wrapText,
            customLeft = null,
            customRight = null,
            noCheckBox = false,
            iconLeftMarginRight = 12,
            iconLeftColor,
            illustration,
            hasIconOptions = false
        },
        ref
    ) => {
        // An illustration behaves like iconLeft: it takes the left slot, so the
        // selected tick goes on the right hand side instead of before the label.
        let defaultTick = !iconLeft && !iconRight && !illustration ? true : !!iconRight ? true : false
        if (noCheckBox) defaultTick = false
        let innerStyle = {
            whiteSpace: 'nowrap',
            flexGrow: 1,
            textAlign: 'left',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        }
        if (wrapText) {
            innerStyle = {
                whiteSpace: 'normal',
                flexGrow: 1,
                textAlign: 'left',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            }
        }
        return (
            <li
                data-tooltip-content={tooltip}
                data-tooltip-id={tooltip ? 'options' + (item.value || item.id) : undefined}
                ref={ref}
            >
                <a
                    style={{
                        display: 'flex',
                        width: '100%',
                        overflow: 'hidden',
                        alignItems: 'center',
                        cursor: disabled ? 'not-allowed' : 'pointer'
                    }}
                    className={disabled ? 'disabled' : ''}
                    disabled={disabled}
                    data-ph={item.postHogTag}
                    onClick={() => (disabled ? {} : onSelect(item))}
                >
                    {!!iconLeft && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {<Icons icon={iconLeft} color={iconLeftColor} style={{ display: 'flex' }} />}
                        </div>
                    )}
                    {!!illustration && (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: iconLeftMarginRight,
                                flex: '0 0 auto'
                            }}
                        >
                            <Icon name={illustration} />
                        </div>
                    )}
                    {!!customLeft && (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: iconLeftMarginRight
                            }}
                        >
                            {customLeft}
                        </div>
                    )}
                    {!!selected && defaultTick && !checkbox && hasIconOptions && (
                        <Icons icon='tick' style={{ height: 20, width: 20 }} className='mar-r10' />
                    )}
                    {!selected && defaultTick && !checkbox && hasIconOptions && (
                        <div style={{ height: 20, width: 20 }} className='mar-r10'>
                            <div style={{ height: 20, width: 20 }}></div>
                        </div>
                    )}
                    {checkbox && (
                        <CheckBox checked={!!selected} disabled={disabled} onChange={() => onSelect(item)} />
                    )}
                    {!item.sublabel && <div style={innerStyle}>{item.label}</div>}
                    {!!item.sublabel && (
                        // A second line explaining the option. It is allowed to
                        // wrap so a long description is never cut off.
                        <div style={{ ...innerStyle, whiteSpace: 'normal' }}>
                            <div>{item.label}</div>
                            <div style={{ fontSize: '12px', color: 'var(--neutral-500)' }}>{item.sublabel}</div>
                        </div>
                    )}
                    {!!selected && (!!iconLeft || !!illustration) && !checkbox && !noCheckBox && (
                        <Icons icon='tick' style={{ height: 20, width: 20 }} className='mar-r10' />
                    )}
                    {!selected && (!!iconLeft || !!illustration) && !checkbox && !noCheckBox && (
                        <div style={{ height: 20, width: 20 }} className='mar-r10'>
                            <div style={{ height: 20, width: 20 }}></div>
                        </div>
                    )}
                    {!!iconRight && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {typeof iconRight !== 'string' || iconRight.indexOf('http') !== 0 ? (
                                <Icons icon={iconRight} />
                            ) : null}
                            {typeof iconRight === 'string' && iconRight.indexOf('http') === 0 && (
                                <Avatar
                                    style={{ height: 20, width: 20, marginLeft: 5, backgroundColor: 'white' }}
                                    for={item.value + '-tooltip'}
                                    tooltip={item.iconRightTooltip}
                                    src={iconRight}
                                />
                            )}
                        </div>
                    )}
                    {!!customRight && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {customRight}
                        </div>
                    )}
                </a>
                {tooltip && <Tooltip id={'options' + (item.value || item.id)} />}
            </li>
        )
    }
)

function Group({ name, options }) {
    return (
        <>
            <div className='select-group'>{name}</div>
            {options}
        </>
    )
}
